import { TFunction } from 'i18next';
import {
  GridActionsCellItem,
  GridAlignment,
  GridEnrichedColDef,
  GridRowParams
} from '@mui/x-data-grid-pro';
import {
  ApprovedIcon,
  DeleteIcon,
  EyesOpenIcon,
  StatusRejectedIcon,
  StatusSuccessIcon
} from '../../../../../lib/icons';
import { ReceiptsCellViewModel } from '../viewModel';
import { ReceiptsRowViewModel } from '../../row/viewModel';

export class ActionsCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  get value() {
    return '';
  }

  onDetailsClicked() {
    this.receipt.openDetails();
  }

  onSettleClicked() {
    this.row.table.actionDialog.open([this.receipt], 'settle');
  }

  onRejectClicked() {
    this.row.table.actionDialog.open([this.receipt], 'reject');
  }

  onDeleteClicked() {
    this.row.table.actionDialog.open([this.receipt], 'delete');
  }

  onApproveClicked() {
    this.row.table.actionDialog.open([this.receipt], 'approve');
    this.row.table.actionDialog.confirm();
  }

  static buildColDef(t: TFunction): GridEnrichedColDef {
    return {
      field: 'actions',
      type: 'actions',
      align: 'right' as GridAlignment,
      width: 20,
      getActions: (params: GridRowParams<ReceiptsRowViewModel>) => [
        <GridActionsCellItem
          icon={<StatusSuccessIcon />}
          onClick={() => params.row.actions.onSettleClicked()}
          label={t('common:SETTLE')}
          sx={{
            display: params.row.receipt.isApplicable('settle') ? 'flex' : 'none'
          }}
          showInMenu
          key={`${params.row.id}-settle`}
          placeholder=""
        />,
        <GridActionsCellItem
          icon={<EyesOpenIcon />}
          label={t('common:DETAILS')}
          onClick={() => {
            params.row.actions.onDetailsClicked();
          }}
          showInMenu
          key={`${params.row.id}-view`}
          placeholder=""
        />,
        <GridActionsCellItem
          icon={<ApprovedIcon />}
          onClick={() => params.row.actions.onApproveClicked()}
          label={t('common:APPROVE')}
          sx={{
            display: params.row.receipt.isApplicable('approve') ? 'flex' : 'none'
          }}
          showInMenu
          key={`${params.row.id}-approve`}
          placeholder=""
        />,
        <GridActionsCellItem
          icon={<StatusRejectedIcon />}
          onClick={() => params.row.actions.onRejectClicked()}
          label={t('common:REJECT')}
          sx={{
            display: params.row.receipt.isApplicable('reject') ? 'flex' : 'none'
          }}
          showInMenu
          key={`${params.row.id}-reject`}
          placeholder=""
        />,
        <GridActionsCellItem
          icon={<DeleteIcon color="error.main" />}
          onClick={() => params.row.actions.onDeleteClicked()}
          label={t('common:DELETE')}
          sx={{
            display: params.row.receipt.isApplicable('delete') ? 'flex' : 'none',
            color: 'error.main',
            '&:hover': { backgroundColor: 'error.light' }
          }}
          showInMenu
          key={`${params.row.id}-delete`}
          placeholder=""
        />
      ]
    };
  }
}
